/* eslint-disable react/require-default-props */
import React from 'react';

interface IArrow {
  border: number;
  length: number;
  color: string;
  rotate?: number;
  marginRight?: string;
}

const Arrow = ({ border, length, color, rotate, marginRight }: IArrow) => {
  return (
    <div
      style={{
        borderBottom: `${border}px solid ${color}`,
        borderRight: `${border}px solid ${color}`,
        transform: `rotate(${rotate || '-45'}deg)`,
        width: `${length}px`,
        height: `${length}px`,
        marginRight: marginRight || '',
      }}
    />
  );
};

export default Arrow;
